import { Spinner } from "@chakra-ui/react";
import type { SpinnerProps } from "@chakra-ui/react";

export const APP_SPINNER_COLOR = "#2F80ED";

export type AppSpinnerProps = SpinnerProps;

export const AppSpinner: React.FC<AppSpinnerProps> = (props) => {
  return (
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="#E5E7EB"
      color={APP_SPINNER_COLOR}
      size="xl"
      {...props}
    />
  );
};

export default AppSpinner;
